module.exports = __webpack_public_path__ + "img/logo3@2x.d6af6ddd.png";